import { Skeleton, ToolCard } from 'odc-shared/components';
import { useLocale } from 'odc-shared/i18n';
import React, { useMemo } from 'react';

import { CommPlatform } from '@src/api/generated/data-contracts';
import website from '@src/constants/website';
import useMobxSelector from '@src/hooks/useMobxSelector';
import { getCategoryFirstPid } from '@src/utils/helpCenter';

import './index.scss';

interface GettingStartedProps {
  platform: CommPlatform;
  /** 目录数据是否是当前语言那一份；false 时卡片区渲染骨架（不渲染上一个语言的卡片） */
  ready?: boolean;
  setPid: (pid: string | undefined) => void;
}

function getImageUrl(path: string) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // 相对路径，拼接域名
  return new URL(path, website.staticBaseUrl).href;
}

const GettingStarted: React.FC<GettingStartedProps> = ({
  platform,
  ready = true,
  setPid,
}) => {
  const catalogsByPlatform = useMobxSelector((stores) => stores.helpCenterStore.catalogsByPlatform);
  const { t } = useLocale('helpCenter');

  const catalogsData = useMemo(() => {
    const catalogs = catalogsByPlatform[platform];
    if (!catalogs) return [];
    return catalogs.map((catalog) => ({
      id: catalog.id,
      title: catalog.name || '',
      desc: catalog.description || '',
      pid: getCategoryFirstPid(catalog),
      icon: getImageUrl(catalog.icon || ''),
    }));
  }, [catalogsByPlatform, platform]);

  return (
    <div className="odc-page-getting-started">
      <div className="odc-page-content">
        <p className="article-title">{t('Getting started')}</p>
        <div className="article-content">
          <div className="tool-card-group">
            {
              ready ? catalogsData.map((catalog) => (
                <ToolCard
                  key={catalog.id}
                  icon={catalog.icon}
                  name={catalog.title}
                  desc={catalog.desc}
                  onClick={() => setPid(catalog.pid)}
                />
              )) : (
                // 目录数据还没到位（或还是上一个语言的）：占位卡片，避免"先空一片、再长出卡片"
                [0, 1, 2, 3].map((index) => (
                  <div className="tool-card-placeholder" key={`placeholder_${index}`}>
                    <Skeleton rows={[{ width: '100%', height: '96px' }]} />
                  </div>
                ))
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;